import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { USER_INTERACTION_REGISTER } from '../graphql/user';
import useDebounce from './useDebounce';

const useReactTrackingLayer = (frontendName) => {
  const utmCampaign = new URLSearchParams(window.location.search).get('utm_campaign') || '';
  const [registerAction] = useMutation(USER_INTERACTION_REGISTER, {
    onError: () => {},
  });
  const executeTracking = useCallback((trackingEvent) => {
    const {
      button,
      action,
      domain,
      route,
      searchParams,
      company,
      isMobile,
      session,
    } = trackingEvent;
    
    registerAction({
      variables: {
        action: {
          frontendName,
          route,
          domain,
          searchParams,
          company: company?.id,
          isMobile,
          action,
          button,
          session,
        },
      },
    });
  }, [registerAction, frontendName, utmCampaign]);

  const debouncedDispatcher = useDebounce(executeTracking, 200);
  
  return debouncedDispatcher;
};

export default useReactTrackingLayer;
